import { defineStore } from "pinia";
import { ref, watch } from "vue";
const STORAGE_KEY = "ppcp.theme";
function systemPrefersDark() {
    return window.matchMedia("(prefers-color-scheme: dark)").matches;
}
function applyTheme(mode) {
    const effective = mode === "system" ? (systemPrefersDark() ? "dark" : "light") : mode;
    document.documentElement.classList.toggle("dark", effective === "dark");
}
function loadInitial() {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored === "light" || stored === "dark" || stored === "system")
        return stored;
    return "system";
}
export const useThemeStore = defineStore("theme", () => {
    const mode = ref(loadInitial());
    // Apply once on store init so first paint is correct (called from main.ts
    // before mount via this same store).
    applyTheme(mode.value);
    watch(mode, (m) => {
        localStorage.setItem(STORAGE_KEY, m);
        applyTheme(m);
    });
    // Keep tracking system changes only when mode === "system"
    const mq = window.matchMedia("(prefers-color-scheme: dark)");
    mq.addEventListener("change", () => {
        if (mode.value === "system")
            applyTheme("system");
    });
    function cycle() {
        // Three-state cycle: light → dark → system → light.
        mode.value = mode.value === "light" ? "dark" : mode.value === "dark" ? "system" : "light";
    }
    return { mode, cycle };
});
